package com.example.positionahead.domain

object CsvImportTemplate {
    const val FILE_NAME = "positionahead-import-template.csv"

    val content: String = """
        # PositionAhead import template
        # Price = average cost per share (match your broker cost basis, e.g. Robinhood avg cost).
        # Quantity = number of shares. Unrealized G/L uses these lots vs live market quotes.
        # Optional: Date (M/D/YYYY), Asset Class (STOCK, ETF, BOND, REIT, CASH)
        # Note: dividends, splits, and pending orders are not imported from CSV yet.
        Symbol,Price,Quantity,,Date
        VXUS,82.46,4.266602,,9/8/2026
        VTI,337.999,3.959334,,9/8/2026
        AVGO,368.47,1.631069,,9/8/2026
    """.trimIndent()
}
